export enum EVENT_TYPES {
  PAGE_VIEW = 'pageView',
  CUSTOM = 'custom',
}
